import { render } from "./RetailerTurnInOrders.vue?vue&type=template&id=67bab56b&scoped=true"
import script from "./RetailerTurnInOrders.vue?vue&type=script&lang=js"
export * from "./RetailerTurnInOrders.vue?vue&type=script&lang=js"

import "./RetailerTurnInOrders.vue?vue&type=style&index=0&id=67bab56b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bab56b"]])

export default __exports__